const os = document.querySelectorAll('.intro__os')
const body = document.querySelector('body')
const winPlatformIcon = document.querySelector('.platform-win .intro__works .windows')
const macPlatformIcon = document.querySelector('.platform-mac .intro__works .mac')

setActiveClass()

function setActiveClass () {
    if (body.classList.contains('win')) {
        if(winPlatformIcon) {
            winPlatformIcon.classList.add('active')
        }
    } else {
        if(macPlatformIcon) {
            macPlatformIcon.classList.add('active')
        }
    }
}

os.forEach(el => el.addEventListener("click", function () {
    os.forEach(el => el.classList.remove('active'))

    if (this.classList.contains("mac")) {
        body.classList.remove('win')
        body.classList.add('mac')
    } else if(this.classList.contains("windows")) {
        body.classList.remove('mac')
        body.classList.add('win')
    }

    if (body.classList.contains('mac')) {
        const macBtns = document.querySelectorAll('.intro__os.mac')
        macBtns.forEach(btn => btn.classList.add('active'))
    } else if (body.classList.contains('win')) {
        const winBtns = document.querySelectorAll('.intro__os.windows')
        winBtns.forEach(btn => btn.classList.add('active'))
    }
}))

if (window.location.pathname === '/video-player/mac') {
    document.addEventListener('DOMContentLoaded', () => {
      body.classList.remove('win')
      body.classList.add('mac')
      setActiveClass()
    })
  }